import React from 'react';
import DocumentTitle from 'react-document-title';

import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import SignUpPage1 from './SignUpPages/Page1'
import SignUpPage2 from './SignUpPages/Page2'
import SignUpPage3 from './SignUpPages/Page3'
import SignUpPage4 from './SignUpPages/Page4'
import * as Cookies from "../utils/Cookies";
import * as Conections from "../utils/Connections";
import $ from "jquery";
import dispatcher from "../utils/dispatcher";
import {Redirect} from "react-router";

export default class SignupPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            steps: ['User Details', 'Address', 'Produce', 'Summary'],
            activeStep: 0,
            signupData: {},
            tohome:false
        }
        this.getStepContent = this.getStepContent.bind(this)
        this.setActiveStep = this.setActiveStep.bind(this)
        this.handleNext = this.handleNext.bind(this)
        this.handleBack = this.handleBack.bind(this)
        this.handleChangeData = this.handleChangeData.bind(this)
        this.handleSignUp = this.handleSignUp.bind(this)
    }

    handleChangeData(name, value) {
        this.state.signupData[name] = value
    }
    handleSignUp() {
        this.state.signupData["type"]="admin_add_client"
        var sendData={
            method:'POST',
            headers:new Headers({
                'Content-Type':'application/x-www-form-urlencoded'
            }),
            body:$.param(this.state.signupData)

        };
        let self=this;
        fetch(Conections.getGeneralAPILink(),sendData)
            .then((resp) => resp.json()) // Transform the data into json
            .then(function(data) {
                if(data.success==0){
                    alert(data.message)
                }else{
                    alert(data.message)
                    self.setState({
                        tohome:true
                    })
                }
            });
    }

    componentDidMount() {
        // window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount() {
        // window.removeEventListener('resize', this.updateWindowDimensions);
    }

    setActiveStep(step) {
        if(step<0){
            this.setState({
                tohome:true
            })
        }
        if (step >= 0 && step <= 4) {
            this.setState({
                activeStep: step
            })
        }
    }


    handleNext() {
        this.setActiveStep(this.state.activeStep + 1)
    }

    handleBack() {
        this.setActiveStep(this.state.activeStep - 1)
    }

    getStepContent(step) {
        switch (step) {
            case 0:
                return 'Select campaign settings...';
            case 1:
                return 'What is an ad group anyways?';
            case 2:
                return 'This is the bit I really care about!';
            default:
                return 'Unknown step';
        }
    }

    render() {
        if (this.state.tohome === true) {
            return <Redirect to='/login' />
        }
        return (

            <DocumentTitle title="Khula - Signup">
                <div id="wrapper">
                    <div>
                        <div style={{
                            width: "50%",
                            marginLeft: "25%",
                            marginRight: "25%"
                        }}>
                            <Stepper activeStep={this.state.activeStep}>
                                {this.state.steps.map((label, index) => {
                                    const stepProps = {};
                                    const labelProps = {};
                                    // if (isStepOptional(index)) {
                                    //     labelProps.optional = <Typography variant="caption">Optional</Typography>;
                                    // }
                                    // if (isStepSkipped(index)) {
                                    //     stepProps.completed = false;
                                    // }
                                    return (
                                        <Step key={label} {...stepProps}>
                                            <StepLabel {...labelProps}>{label}</StepLabel>
                                        </Step>
                                    );
                                })}

                            </Stepper>
                        </div>
                        <div>
                            {this.state.activeStep === this.state.steps.length-1 ? (
                                <div>
                                    <SignUpPage4 data={this.state.signupData}/>
                                    <div className="uk-grid-small uk-flex-row uk-text-center" style={{
                                        width: "30%",
                                        marginLeft: "35%",
                                        marginRight: "35%",
                                        marginTop: "1%"
                                    }}>
                                        <div className="col-sm-6 col-xs-6 col-lg-6 col-md-6">
                                            <Button disabled={this.state.activeStep === 0} onClick={this.handleBack}
                                                    style={{
                                                        background: "#5b7f8f",
                                                        color: "#fff"
                                                    }}>
                                                Back
                                            </Button>
                                        </div>
                                        <div className="col-sm-6 col-xs-6 col-lg-6 col-md-6">
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={this.handleSignUp}
                                            >
                                                {"Sign Up"}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    {this.state.activeStep == 0 && <SignUpPage1 changer={() => this}/>}
                                    {this.state.activeStep == 1 && <SignUpPage2 changer={() => this}/>}
                                    {this.state.activeStep == 2 && <SignUpPage3 changer={() => this}/>}
                                    <div className="uk-grid-small uk-flex-row uk-text-center" style={{
                                        width: "30%",
                                        marginLeft: "35%",
                                        marginRight: "35%",
                                        marginTop: "1%"
                                    }}>
                                        <div className="col-sm-6 col-xs-6 col-lg-6 col-md-6">
                                            <Button  onClick={this.handleBack}
                                                    style={{
                                                        background: "#5b7f8f",
                                                        color: "#fff"
                                                    }}>
                                                {this.state.activeStep === 0 ? 'Cancel' : 'Back'}
                                            </Button>
                                        </div>
                                        <div className="col-sm-6 col-xs-6 col-lg-6 col-md-6">
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={this.handleNext}
                                            >
                                                {this.state.activeStep === this.state.steps.length - 1 ? 'Finish' : 'Next'}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </DocumentTitle>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/SignupPage.js